export const ENCOUNTER_METHODS = {
  WALK: 1,
  OLD_ROD: 2,
  GOOD_ROD: 3,
  SUPER_ROD: 4,
  SURF: 5,
  ROCK_SMASH: 6,
  HEADBUTT: 7,
  DARK_GRASS: 8,
  GRASS_SPOTS: 9,
  CAVE_SPOTS: 10,
  BRIDGE_SPOTS: 11,
  SUPER_ROD_SPOTS: 12,
  SURF_SPOTS: 13,
  YELLOW_FLOWERS: 14,
  PURPLE_FLOWERS: 15,
  RED_FLOWERS: 16,
  ROUGH_TERRAIN: 17,
  GIFT: 18,
  GIFT_EGG: 19,
  STATIC: 20,
  POKEFLUTE: 21,
  HEADBUTT_LOW: 22,
  HEADBUTT_NORMAL: 23,
  HEADBUTT_HIGH: 24,
  SQUIRT_BOTTLE: 25,
  WAILMER_PAIL: 26,
  SEAWEED: 27,
  ROAMING_GRASS: 28,
  ROAMING_WATER: 29,
  DEVON_SCOPE: 30,
  FEEBAS_TILE_FISHING: 31,
  ISLAND_SCAN: 32,
  SOS: 33,
  BUBBLING_SPOTS: 34,
  BERRY_TREES: 35,
  NPC_TRADE: 36,
  SOS_FROM_BUBBLING_SPOT: 37,
  OVERWORLD: 38,
  OVERWORLD_WATER: 39,
  OVERWORLD_FLYING: 40,
  OVERWORLD_SPECIAL: 41,
  OVERWORLD_FLYING_SPECIAL: 42,
  OVERWORLD_WATER_SPECIAL: 43,
  HORDE: 44,
  COLOSSEUM_BONUS_DISC_US: 45,
  COLOSSEUM_BONUS_DISC_JPN: 46,
  POKEMON_CHANNEL_PAL: 47,
  POKEMON_RANGER: 48,
  POKEMON_BATTLE_REVOLUTION: 49,
  NEW_YORK_POKECENTER_WISH_EGGS: 50,
  SNAG: 51,
  SNAG_REMATCH: 52,
  POKESPOT: 53,
  HIDDEN_GROTTO: 54,
  HONEY_TREE: 55,
  OVERWORLD_DIRT: 56,
  WANDERER: 57,
  WANDERER_WATER: 58,
  CHASE_WATER: 59,
  DYNAMAX_ADVENTURE: 60,
  MAX_RAID: 61,
  TRASH_CAN_AMBUSH: 62,
  RUSTLING_BUSH_AMBUSH: 63,
  CEILING_AMBUSH: 64,
  GROUND_AMBUSH: 65,
  SKY_AMBUSH: 66,
  /**
   * @deprecated Misspelled: the endpoint names this `headbutt-high`.
   *   Use {@link ENCOUNTER_METHODS.HEADBUTT_HIGH}. Removed in 3.0.
   */
  HEADBUT_HIGH: 24,
  /**
   * @deprecated The endpoint names this `static` now.
   *   Use {@link ENCOUNTER_METHODS.STATIC}. Removed in 3.0.
   */
  ONLY_ONE: 20,
} as const;

export const ENCOUNTER_CONDITIONS = {
  SWARM: 1,
  TIME: 2,
  RADAR: 3,
  SLOT2: 4,
  RADIO: 5,
  SEASON: 6,
  STARTER: 7,
  TV_OPTION: 8,
  STORY_PROGRESS: 9,
  OTHER: 10,
  ITEM: 11,
  WEEKDAY: 12,
  FIRST_PARTY_POKEMON: 13,
  SPECIAL_ENCOUNTER: 14,
  TRADE: 15,
  COINS: 16,
  FRIEND_SAFARI_SLOT: 17,
  GREAT_MARSH_DAILY_SLOT: 18,
  HONEY_TREE_GROUP: 19,
  HEADBUTT_TREE: 20,
  BACKLOT: 21,
  BUG_CATCHING_CONTEST: 22,
  SAVE_DATA: 23,
  ALOLAN_DIGLETT_FOUND: 24,
  WEATHER: 25,
  JOHTO_SAFARI_BLOCKS: 26,
  MAX_DEN_RARITY: 27,
  MAX_DEN_RATING: 28,
  BERRY_TREE_TYPE: 29,
  TRASH_CAN_TYPE: 30,
} as const;

export const ENCOUNTER_CONDITION_VALUES = {
  SWARM_YES: 1,
  SWARM_NO: 2,
  TIME_MORNING: 3,
  TIME_DAY: 4,
  TIME_NIGHT: 5,
  RADAR_ON: 6,
  RADAR_OFF: 7,
  SLOT2_NONE: 8,
  SLOT2_RUBY: 9,
  SLOT2_SAPPHIRE: 10,
  SLOT2_EMERALD: 11,
  SLOT2_FIRERED: 12,
  SLOT2_LEAFGREEN: 13,
  RADIO_OFF: 14,
  RADIO_HOENN: 15,
  RADIO_SINNOH: 16,
  SEASON_SPRING: 17,
  SEASON_SUMMER: 18,
  SEASON_AUTUMN: 19,
  SEASON_WINTER: 20,
  STARTER_BULBASAUR: 21,
  STARTER_SQUIRTLE: 22,
  STARTER_CHARMANDER: 23,
  STARTER_CHESPIN: 24,
  STARTER_FENNEKIN: 25,
  STARTER_FROAKIE: 26,
  TV_OPTION_BLUE: 27,
  TV_OPTION_RED: 28,
  STORY_PROGRESS_AWAKENED_BEASTS: 29,
  STORY_PROGRESS_BEAT_GALACTIC_CORONET: 30,
  STORY_PROGRESS_OAK_ETERNA_CITY: 31,
  STORY_PROGRESS_VERMILION_COPYCAT: 32,
  STORY_PROGRESS_MET_TORNADUS_THUNDURUS: 33,
  STORY_PROGRESS_BEAT_ELITE_FOUR_ROUND_TWO: 34,
  STORY_PROGRESS_HALL_OF_FAME: 35,
  STORY_PROGRESS_NONE: 36,
  STORY_PROGRESS_NATIONAL_DEX: 37,
  OTHER_NONE: 38,
  OTHER_SNORLAX_11_BEAT_LEAGUE: 39,
  OTHER_VIRTUAL_CONSOLE: 40,
  STORY_PROGRESS_CURE_ELDRITCH_NIGHTMARES: 41,
  OTHER_TALK_TO_CYNTHIAS_GRANDMOTHER: 42,
  ITEM_NONE: 43,
  ITEM_ADAMANT_ORB: 44,
  ITEM_LUSTROUS_ORB: 45,
  ITEM_HELIX_FOSSIL: 46,
  ITEM_DOME_FOSSIL: 47,
  ITEM_OLD_AMBER: 48,
  ITEM_ROOT_FOSSIL: 49,
  ITEM_CLAW_FOSSIL: 50,
  STORY_PROGRESS_DEFEAT_JUPITER: 51,
  STORY_PROGRESS_BEAT_TEAM_GALACTIC_IRON_ISLAND: 52,
  OTHER_CORRECT_PASSWORD: 53,
  STORY_PROGRESS_ZEPHYR_BADGE: 54,
  STORY_PROGRESS_BEAT_RED: 55,
  OTHER_RECEIVED_KANTO_STARTER: 56,
  STORY_PROGRESS_RECEIVE_TM_FROM_CLAIRE: 57,
  OTHER_REGIROCK_REGICE_REGISTEEL_IN_PARTY: 58,
  WEEKDAY_SUNDAY: 59,
  WEEKDAY_MONDAY: 60,
  WEEKDAY_TUESDAY: 61,
  WEEKDAY_WEDNESDAY: 62,
  WEEKDAY_THURSDAY: 63,
  WEEKDAY_FRIDAY: 64,
  WEEKDAY_SATURDAY: 65,
  FIRST_PARTY_POKEMON_HIGH_FRIENDSHIP: 66,
  STORY_PROGRESS_DEFEAT_MARS: 67,
  ITEM_ODD_KEYSTONE: 68,
  OTHER_TALKED_TO_32_PEOPLE_UNDERGROUND: 69,
  STORY_PROGRESS_RETURNED_MACHINE_PART: 70,
  OTHER_EVENT_ARCEUS_IN_PARTY: 71,
  SPECIAL_ENCOUNTER_COULDNT_CAPTURE_BEFORE: 72,
  ITEM_ICE_KEY: 73,
  ITEM_IRON_KEY: 74,
  STORY_PROGRESS_JUNIPER_CAVE_OF_BEING: 75,
  ITEM_LUNAR_WING: 76,
  STORY_PROGRESS_QUAKE_BADGE: 77,
  ITEM_LIGHT_STONE: 78,
  ITEM_DARK_STONE: 79,
  OTHER_CAPTURED_RESHIRAM_OR_ZEKROM: 80,
  DEFEATED_GHETSIS: 81,
  OTHER_FOUND_11_TIMES_ROAMING: 82,
  TIME_MINUTE_00_TO_19: 83,
  TIME_MINUTE_20_TO_39: 84,
  TIME_MINUTE_40_TO_59: 85,
  TIME_04_00_TO_19_59: 86,
  TIME_20_00_TO_21_59: 87,
  TIME_21_00_TO_03_59: 88,
  ITEM_TIDAL_BELL: 89,
  ITEM_CLEAR_BELL: 90,
  STORY_PROGRESS_DEFEATED_GROUDON_OR_KYOGRE: 91,
  OTHER_UXIE_MESPRIT_AZELF_IN_PARTY: 92,
  OTHER_NICKNAMED_COLD_ITEM_REGICE_REGIROCK_REGISTEEL3: 93,
  OTHER_DIALGA_OR_PALKIA_IN_PARTY: 94,
  OTHER_CASTFORM_IN_PARTY: 95,
  OTHER_LEVEL_100_POKEMON_IN_PARTY: 96,
  OTHER_TORNADUS_THUNDURUS_IN_PARTY: 97,
  OTHER_RESHIRAM_ZEKROM_IN_PARTY: 98,
  OTHER_CAPTURED_ALL_ULTRA_BEASTS: 99,
  STORY_PROGRESS_FINISHED_LOOKER_SIDEQUEST: 100,
  STORY_PROGRESS_BEAT_OLIVIAS_TRIAL: 101,
  OTHER_RAIKOU_ENTEI_IN_PARTY: 102,
  OTHER_GROUDON_KYOGRE_IN_PARTY: 103,
  OTHER_DIALGA_PALKIA_IN_PARTY: 104,
  OTHER_SCAN_QR_CODE: 105,
  OTHER_CAUGHT_ARTICUNO: 106,
  OTHER_CAUGHT_ZAPDOS: 107,
  OTHER_CAUGHT_MOLTRES: 108,
  TRADE_TOGEPI_OR_TOGETIC: 109,
  TRADE_TRAPINCH: 110,
  TRADE_SURSKIT: 111,
  TRADE_WOOPER: 112,
  STORY_PROGRESS_CATCH_ALL_SHADOW_POKEMON: 113,
  OTHER_COMPLETE_MT_BATTLE: 114,
  COINS_180: 115,
  COINS_500: 116,
  COINS_1200: 117,
  COINS_2800: 118,
  COINS_5500: 119,
  COINS_9999: 120,
  COINS_120: 121,
  COINS_750: 122,
  COINS_2500: 123,
  COINS_4600: 124,
  COINS_6500: 125,
  COINS_230: 126,
  COINS_1000: 127,
  COINS_2680: 128,
  COINS_3333: 129,
  COINS_6666: 130,
  COINS_200: 131,
  COINS_700: 132,
  COINS_2100: 133,
  COINS_100: 134,
  COINS_800: 135,
  COINS_1500: 136,
  COINS_2222: 137,
  COINS_5555: 138,
  COINS_8888: 139,
  COINS_150: 140,
  COINS_620: 141,
  COINS_2880: 142,
  COINS_5400: 143,
  COINS_8300: 144,
  TRADE_ABRA: 145,
  TRADE_NIDORAN_M: 146,
  TRADE_NIDORINO: 147,
  TRADE_SLOWBRO: 148,
  TRADE_POLIWHIRL: 149,
  TRADE_SPEAROW: 150,
  TRADE_RAICHU: 151,
  TRADE_VENONAT: 152,
  TRADE_PONYTA: 153,
  TRADE_CLEFAIRY: 154,
  TRADE_CUBONE: 155,
  TRADE_LICKITUNG: 156,
  TRADE_TANGELA: 157,
  TRADE_GOLDUCK: 158,
  TRADE_GROWLITHE: 159,
  TRADE_KANGASKHAN: 160,
  TRADE_BELLSPROUT: 161,
  TRADE_DROWZEE: 162,
  TRADE_KRABBY: 163,
  TRADE_DRAGONAIR: 164,
  TRADE_CHANSEY: 165,
  TRADE_GLOOM: 166,
  TRADE_HAUNTER: 167,
  TRADE_DUGTRIO: 168,
  TRADE_SLAKOTH: 169,
  TRADE_PIKACHU: 170,
  TRADE_BELLOSSOM: 171,
  TRADE_RALTS: 172,
  TRADE_VOLBEAT: 173,
  TRADE_BAGON: 174,
  TRADE_SKITTY: 175,
  FRIEND_SAFARI_SLOT_1: 176,
  FRIEND_SAFARI_SLOT_2: 177,
  FRIEND_SAFARI_SLOT_3: 178,
  ITEM_SKULL_FOSSIL: 179,
  ITEM_ARMOR_FOSSIL: 180,
  GREAT_MARSH_DAILY_SLOT_NONE: 181,
  GREAT_MARSH_DAILY_SLOT_1_OF_32: 182,
  GREAT_MARSH_DAILY_SLOT_2_OF_32: 183,
  GREAT_MARSH_DAILY_SLOT_3_OF_32: 184,
  GREAT_MARSH_DAILY_SLOT_5_OF_32: 185,
  STORY_PROGRESS_BEFORE_NATIONAL_DEX: 186,
  GREAT_MARSH_DAILY_SLOT_4_OF_32: 187,
  GREAT_MARSH_DAILY_SLOT_15_OF_32: 188,
  HONEY_TREE_GROUP_A: 189,
  HONEY_TREE_GROUP_B: 190,
  HONEY_TREE_GROUP_C: 191,
  HEADBUTT_TREE_COMMON: 192,
  HEADBUTT_TREE_RARE: 193,
  HEADBUTT_TREE_SECRET: 194,
  TRADE_COTTONEE: 195,
  TRADE_PETILIL: 196,
  TRADE_EMOLGA: 197,
  TRADE_MANTINE: 198,
  TRADE_DITTO: 199,
  TRADE_EXCADRILL: 200,
  TRADE_HIPPOWDON: 201,
  BACKLOT_NOT_MENTIONED: 202,
  BACKLOT_MENTIONED: 203,
  BUG_CATCHING_CONTEST_NO: 204,
  BUG_CATCHING_CONTEST_YES: 205,
  SAVE_DATA_FROM_LETS_GO_PIKACHU: 206,
  SAVE_DATA_FROM_LETS_GO_EEVEE: 207,
  ITEM_FOSSILIZED_BIRD: 208,
  ITEM_FOSSILIZED_DRAKE: 209,
  ITEM_FOSSILIZED_DINO: 210,
  ITEM_FOSSILIZED_FISH: 211,
  STORY_PROGRESS_MASTER_DOJO_COMPLETE_FIRST_TRIAL: 212,
  STORY_PROGRESS_MASTER_DOJO_COMPLETE_THIRD_TRIAL: 213,
  ALOLAN_DIGLETT_FOUND_5: 214,
  ALOLAN_DIGLETT_FOUND_10: 215,
  ALOLAN_DIGLETT_FOUND_20: 216,
  ALOLAN_DIGLETT_FOUND_30: 217,
  ALOLAN_DIGLETT_FOUND_40: 218,
  ALOLAN_DIGLETT_FOUND_50: 219,
  ALOLAN_DIGLETT_FOUND_75: 220,
  ALOLAN_DIGLETT_FOUND_100: 221,
  ALOLAN_DIGLETT_FOUND_150: 222,
  STARTER_GROOKEY: 223,
  STARTER_SCORBUNNY: 224,
  STARTER_SOBBLE: 225,
  STORY_PROGRESS_SAVE_VILLAGE_FROM_GLASTRIER_SPECTRIER: 226,
  STORY_PROGRESS_CATCH_FIVE_ULTRA_BEASTS: 227,
  TRADE_BUNNELBY: 228,
  TRADE_MEOWTH_GALAR: 229,
  TRADE_MINCCINO: 230,
  TRADE_TOXEL: 231,
  TRADE_MARACTUS: 232,
  TRADE_YAMASK_GALAR: 233,
  TRADE_VANILLISH: 234,
  TRADE_OBSTAGOON: 235,
  TRADE_FROSMOTH: 236,
  TRADE_FARFETCHD_GALAR: 237,
  TRADE_CORSOLA_GALAR: 238,
  TRADE_PONYTA_GALAR: 239,
  TRADE_MR_MIME_GALAR: 240,
  TRADE_DARUMAKA_GALAR: 241,
  TRADE_ZIGZAGOON_GALAR: 242,
  TRADE_STUNFISK_GALAR: 243,
  TRADE_WEEZING_GALAR: 244,
  TRADE_EXEGGUTOR: 245,
  TRADE_MAROWAK: 246,
  WEATHER_NORMAL: 247,
  WEATHER_OVERCAST: 248,
  WEATHER_RAINING: 249,
  WEATHER_THUNDERSTORM: 250,
  WEATHER_SNOWING: 251,
  WEATHER_SNOWSTORM: 252,
  WEATHER_SANDSTORM: 253,
  WEATHER_INTENSE_SUN: 254,
  WEATHER_FOG: 255,
  STORY_PROGRESS_BEFORE_HALL_OF_FAME: 256,
  JOHTO_SAFARI_BLOCKS_INACTIVE: 257,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_2: 258,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_3: 259,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_4: 260,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_5: 261,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_6: 262,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_10: 263,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_12: 264,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_14: 265,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_15: 266,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_24: 267,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_28: 268,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_35: 269,
  JOHTO_SAFARI_BLOCKS_PLAINS_MIN_49: 270,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_3: 271,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_4: 272,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_5: 273,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_8: 274,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_10: 275,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_14: 276,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_15: 277,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_18: 278,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_20: 279,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_28: 280,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_35: 281,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_42: 282,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_49: 283,
  JOHTO_SAFARI_BLOCKS_FOREST_MIN_56: 284,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_3: 285,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_4: 286,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_5: 287,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_6: 288,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_8: 289,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_10: 290,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_15: 291,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_21: 292,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_24: 293,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_28: 294,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_35: 295,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_42: 296,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_49: 297,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_56: 298,
  JOHTO_SAFARI_BLOCKS_PEAK_MIN_63: 299,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_2: 300,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_3: 301,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_4: 302,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_5: 303,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_6: 304,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_7: 305,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_8: 306,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_9: 307,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_10: 308,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_12: 309,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_13: 310,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_14: 311,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_15: 312,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_16: 313,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_18: 314,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_20: 315,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_24: 316,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_28: 317,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_35: 318,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_42: 319,
  JOHTO_SAFARI_BLOCKS_WATER_MIN_49: 320,
  ITEM_COVER_FOSSIL: 321,
  ITEM_PLUME_FOSSIL: 322,
  OTHER_GIRATINA_NOT_CAUGHT_IN_DISTORTION_WORLD: 323,
  OTHER_FIND_50_CAVERN_FOOTPRINTS: 324,
  OTHER_FIND_50_GRASSLAND_FOOTPRINTS: 325,
  OTHER_FIND_50_IRON_WILL_FOOTPRINTS: 326,
  OTHER_REGIROCK_REGICE_REGISTEEL_REGIELEKI_REGIDRAGO_IN_PARTY: 327,
  OTHER_CHOOSE_REGIELEKI_PATTERN: 328,
  OTHER_CHOOSE_REGIDRAGO_PATTERN: 329,
  OTHER_GROW_ICEROOT_CARROT: 330,
  OTHER_GROW_SHADEROOT_CARROT: 331,
  OTHER_TALKED_TO_32_PEOPLE: 332,
  OTHER_EAT_CURRY_WITH_COBALION_TERRAKION_VIRIZION: 333,
  ITEM_REINS_OF_UNITY: 334,
  OTHER_WITNESS_GALARIAN_BIRD_FIGHT: 335,
  MAX_DEN_RARITY_COMMON: 336,
  MAX_DEN_RARITY_RARE: 337,
  MAX_DEN_RATING_1_STAR: 338,
  MAX_DEN_RATING_2_STAR: 339,
  MAX_DEN_RATING_3_STAR: 340,
  MAX_DEN_RATING_4_STAR: 341,
  MAX_DEN_RATING_5_STAR: 342,
  MAX_DEN_RARITY_SPECIAL: 343,
  BERRY_TREE_TYPE_RED: 344,
  BERRY_TREE_TYPE_BLUE: 345,
  BERRY_TREE_TYPE_PURPLE: 346,
  BERRY_TREE_TYPE_GREEN: 347,
  BERRY_TREE_TYPE_YELLOW: 348,
  BERRY_TREE_TYPE_PINK: 349,
  TRASH_CAN_TYPE_DAILY: 350,
  TRASH_CAN_TYPE_TUESDAY: 351,
  TRASH_CAN_TYPE_THURSDAY: 352,
  TRADE_NIDORAN_F: 353,
  TRADE_NIDORINA: 354,
  TRADE_MACHOP: 355,
  TRADE_BUIZEL: 356,
  TRADE_MEDICHAM: 357,
  TRADE_FINNEON: 358,
  TRADE_FORRETRESS: 359,
  TRADE_BONSLY: 360,
  TRADE_ANY_POKEMON: 361,
  /**
   * @deprecated Misspelled: the endpoint names this `other-snorlax-11-beat-league`.
   *   Use {@link ENCOUNTER_CONDITION_VALUES.OTHER_SNORLAX_11_BEAT_LEAGUE}. Removed in 3.0.
   */
  OTHER_SNORLAX_LL_BEAT_LEAGUE: 39,
  /**
   * @deprecated Misspelled: the endpoint names this `radio-hoenn`.
   *   Use {@link ENCOUNTER_CONDITION_VALUES.RADIO_HOENN}. Removed in 3.0.
   */
  RADIO_HOEN: 15,
  /**
   * @deprecated Misspelled: the endpoint names this `slot2-sapphire`.
   *   Use {@link ENCOUNTER_CONDITION_VALUES.SLOT2_SAPPHIRE}. Removed in 3.0.
   */
  SLOT2_SAPHIRE: 10,
  /**
   * @deprecated The endpoint names this `story-progress-vermilion-copycat` now.
   *   Use {@link ENCOUNTER_CONDITION_VALUES.STORY_PROGRESS_VERMILION_COPYCAT}. Removed in 3.0.
   */
  STORY_PROGRESS_OAK_VERMILION_COPYCAT: 32,
  /**
   * @deprecated Misspelled: the endpoint names this `season-autumn`.
   *   Use {@link ENCOUNTER_CONDITION_VALUES.SEASON_AUTUMN}. Removed in 3.0.
   */
  SWASON_AUTUMN: 19,
} as const;
